import {OutfitDetailPageContext} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {ContentViewEvent, trackContentView} from './trackContentView';

export const trackOutfitView =
  ({page}: {page: OutfitDetailPageContext}) =>
  (clientState: TrackingClientStateHolder): ContentViewEvent => {
    return trackContentView({page})(clientState);
  };
